function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import EllipsoidTerrainProvider from "terriajs-cesium/Source/Core/EllipsoidTerrainProvider";
import sampleTerrainMostDetailed from "terriajs-cesium/Source/Core/sampleTerrainMostDetailed";
import ScreenSpaceEventHandler from "terriajs-cesium/Source/Core/ScreenSpaceEventHandler";
import ScreenSpaceEventType from "terriajs-cesium/Source/Core/ScreenSpaceEventType";
import isDefined from "../../../Core/isDefined";
import MouseTooltip from "./MouseTooltip";
import { jsx as _jsx } from "react/jsx-runtime";
const DropPedestrianToGround = props => {
  const cesium = props.cesium;
  const scene = cesium.scene;
  const eventHandler = new ScreenSpaceEventHandler(scene.canvas);
  const [t] = useTranslation();
  const [showMouseTooltip, setShowMouseTooltip] = useState(true);
  useEffect(function setupEventHandlers() {
    // Pause feature picking while we select a drop point on the map.
    cesium.isFeaturePickingPaused = true;
    const dropPedestrian = _ref => {
      let {
        position: mousePosition
      } = _ref;
      // Convert mouse position to a point on the globe.
      const pickRay = scene.camera.getPickRay(mousePosition);
      const pickPosition = isDefined(pickRay) ? scene.globe.pick(pickRay, scene) : undefined;
      if (!pickPosition) return;
      setShowMouseTooltip(false);
      // Get the precise position and fly to it.
      getPrecisePosition(scene, pickPosition).then(cartographic => {
        cartographic.height += props.pedestrianHeight;
        const position = Cartographic.toCartesian(cartographic);
        flyTo(scene, position, {
          orientation: {
            heading: scene.camera.heading,
            pitch: 0,
            roll: 0
          }
        }).then(props.afterDrop);
      });
    };
    const onKeyDown = ev => {
      if (ev.key === "Escape") props.onDropCancelled();
    };
    eventHandler.setInputAction(dropPedestrian, ScreenSpaceEventType.LEFT_CLICK);
    eventHandler.setInputAction(props.onDropCancelled, ScreenSpaceEventType.RIGHT_CLICK);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      eventHandler.destroy();
      cesium.isFeaturePickingPaused = false;
    };
  });
  return showMouseTooltip ? /*#__PURE__*/_jsx(MouseTooltip, {
    scene: scene,
    text: t("pedestrianMode.dropPedestrianTooltipMessage")
  }) : null;
};
async function getPrecisePosition(scene, position) {
  const terrainProvider = scene.terrainProvider;
  const cartographic = Cartographic.fromCartesian(position);
  let preciseCartographic;
  if (terrainProvider === undefined || terrainProvider instanceof EllipsoidTerrainProvider) {
    preciseCartographic = cartographic;
    preciseCartographic.height = Math.max(0, preciseCartographic.height);
  } else {
    [preciseCartographic] = await sampleTerrainMostDetailed(terrainProvider, [cartographic]);
  }
  return preciseCartographic;
}
async function flyTo(scene, destination, options) {
  return new Promise(resolve => scene.camera.flyTo(_objectSpread(_objectSpread({
    destination
  }, options), {}, {
    complete: () => {
      scene.requestRender();
      resolve();
    }
  })));
}
export default DropPedestrianToGround;